// React
import { useState } from "react";
// コンポーネント
import UpdatePasswordInput from "./UpdatePasswordInput";
import UpdatePasswordSuccess from "./UpdatePasswordSuccess";

const UpdatePassword = () => {
    // パスワード変更のステップに関する設定
    const [nextStep, setNextStep] = useState('step1');

    const handleClick = (step) => {
        setNextStep(step);
    };

    return (
        <div>
            {nextStep === 'step1' && <UpdatePasswordInput
            onClick={() => handleClick('step2') }
            />}
            {nextStep === 'step2' && <UpdatePasswordSuccess/>}
        </div>
    )
}

export default UpdatePassword;